(() => {
  'use strict';
  const choices = new Map();
  if (!customElements.get('jb-stone-origin')) {
    customElements.define('jb-stone-origin', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.select = this.querySelector('select[data-jb-stone-origin]');
        const saved = choices.get(this.dataset.productId);
        if (saved && this.select) this.select.value = saved;
        this.addEventListener('change', event => {
          if (event.target !== this.select) return;
          event.stopPropagation();
          choices.set(this.dataset.productId, this.select.value);
          document.querySelectorAll('jb-stone-origin').forEach(other => {
            if (other !== this && other.dataset.productId === this.dataset.productId) other.querySelector('select').value = this.select.value;
          });
        }, { signal: this.abort.signal });
      }
      disconnectedCallback() { this.abort?.abort(); this.abort = null; }
    });
  }
  function field(form, name, value) {
    let input = form.querySelector(`input[name="contact[${name}]"]`);
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = `contact[${name}]`; form.append(input); }
    input.value = value; input.disabled = !value;
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('button.jb-request-price-button');
    if (!button) return;
    const info = button.closest('[data-jb-quote-product="true"]');
    if (!info) return;
    const select = info.querySelector('select[data-jb-stone-origin]');
    if (select && !select.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); select.focus(); return; }
    const form = document.querySelector('#RequestPriceForm');
    if (!form) return;
    const value = select?.value || '';
    field(form, 'Stone origin', value);
    field(form, 'Origin applies to', value ? 'All diamonds and colored gemstones in the complete creation; Akoya pearls remain cultured.' : '');
    const options = Array.from(info.querySelectorAll('fieldset[data-index]')).map(group => {
      const picked = group.querySelector('select')?.value || group.querySelector('input:checked')?.value;
      const label = group.querySelector('legend')?.textContent.trim() || group.dataset.handle || '';
      return picked && picked !== 'Default Title' ? `${label}: ${picked}` : '';
    }).filter(Boolean);
    field(form, 'Selected options', options.join('; '));
    const summary = form.querySelector('[data-jb-origin-summary]');
    if (summary) { summary.textContent = value ? `${summary.dataset.label}: ${select.selectedOptions[0].textContent.trim()}` : ''; summary.hidden = !value; }
  }, true);
  document.addEventListener('keydown', event => {
    const dialog = document.querySelector('#jb-request-price-dialog.active');
    if (!dialog || event.key !== 'Tab') return;
    const nodes = Array.from(dialog.querySelectorAll('button, input:not([type="hidden"]), select, textarea, a[href]')).filter(el => !el.disabled && el.getClientRects().length);
    if (!nodes.length) return;
    const first = nodes[0], last = nodes[nodes.length - 1];
    if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  function normalize(value) { return (value || '').replace(/Platinum/gi, '').replace(/[^a-z0-9]/gi, '').toLowerCase(); }
  function matchSpecifications(info) {
    const configurations = Array.from(info.querySelectorAll('[data-jb-spec-option]'));
    if (configurations.length < 2) return;
    const values = Array.from(info.querySelectorAll('fieldset[data-index] select, fieldset[data-index] input:checked')).map(el => normalize(el.value));
    const active = configurations.find(el => values.includes(normalize(el.dataset.jbSpecOption)));
    configurations.forEach(el => { el.hidden = !!active && el !== active; });
  }
  document.addEventListener('change', event => {
    const info = event.target.closest?.('[data-jb-quote-product="true"]');
    if (info) queueMicrotask(() => matchSpecifications(info));
  });
  const observer = new MutationObserver(records => {
    const scopes = new Set();
    for (const record of records) {
      if (record.type !== 'childList' || !record.addedNodes.length) continue;
      const info = record.target.closest?.('[data-jb-quote-product="true"]');
      if (info) scopes.add(info);
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('[data-jb-quote-product="true"]')) scopes.add(node);
        node.querySelectorAll('[data-jb-quote-product="true"]').forEach(el => scopes.add(el));
      }
    }
    scopes.forEach(matchSpecifications);
  });
  function init() { document.querySelectorAll('[data-jb-quote-product="true"]').forEach(matchSpecifications); observer.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
